import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL, handleNotOkHttpResponse } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import Preloader from "../common/Preloader";
import { isoToDate } from "../../utils/helpers";
import { Button, Modal } from "react-bootstrap";

function PlantingTable({ plantingrecords, allowEdit }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [showPreloader, setShowPreloader] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "View",
            icon: "icon-eye1",
            onClick: (process) => {
                handleShowViewModal(process);
            },
        },
        {
            id: 1,
            name: "Edit",
            icon: "icon-edit1",
            routerPath: "/plantingrecord/edit",
            authType: 'admin',
        },
        {
            id: 3,
            name: "Delete",
            icon: "icon-delete",
            onClick: (process) => {
                handleShowDeleteModal(process);
            },
            authType: 'admin',
        }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        if (plantingrecords && plantingrecords.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        // { width: "12%", targets: 3 } 
                    ]
                });
            });
        }
    }, [plantingrecords, $]);

    const handleShowViewModal = (record) => {
        setSelectedRecord(record);
        setShowViewModal(true);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedRecord(null);
    };

    const handleShowDeleteModal = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedRecord(null);
    };

    const handleRemovePlanting = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }

        setShowPreloader(true);
        try {
            if (!selectedRecord) {
                console.error('No selected Record');
                return;
            }

            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
            };

            const response = await fetch(`${baseURL}/plantingrecords/${selectedRecord.id}`, requestOptions);
            if (response.ok) {
                toast.success("Planting Record removed successfully");
                handleCloseDeleteModal();
                setShowPreloader(true);
                window.location.reload();
            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Planting Record:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };

    return (
        <>
            <Preloader show={showPreloader} />
            <div className="card-body pt-0">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="table-responsive">
                            <table id="data-table" className="table custom-table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>Code</th>
                                        <th>Serial Number</th>
                                        <th>Planting Date</th>
                                        <th>Expected Yield</th>
                                        <th>Planting Material Form</th>
                                        <th>Source</th>
                                        <th>Treatment Before Planting</th>
                                        <th><div className="float-end">Actions</div></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plantingrecords && plantingrecords.length > 0 ? plantingrecords.map((plantingRecord, index) => (
                                        <tr key={index}>
                                            <td>{plantingRecord.code ? plantingRecord.code : '--'}</td>
                                            <td>{plantingRecord.serialNumber ? plantingRecord.serialNumber : '--'}</td>
                                            <td>{isoToDate(plantingRecord.date)}</td>
                                            <td>{plantingRecord.expectedYield}</td>
                                            <td>{plantingRecord.plantingMaterialForm}</td>
                                            <td>{plantingRecord.source}</td>
                                            <td>{plantingRecord.treatmentBeforePlanting}</td>
                                            <td className="">
                                                <ul>
                                                    <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                        <div className="dropdown">
                                                            <Link
                                                                className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                role="button"
                                                                to="#"
                                                                id={"dropdownMenuLink" + plantingRecord.id}
                                                                data-bs-toggle="dropdown"
                                                            >
                                                                Actions <i className="fa fa-caret-down"></i>
                                                            </Link>
                                                            <ul
                                                                className="dropdown-menu"
                                                                aria-labelledby={"dropdownMenuLink" + plantingRecord.id}
                                                            >
                                                                {profileMenuItems.map((actionMenuItem) => (
                                                                    <>
                                                                        {(!actionMenuItem.authType || (actionMenuItem.authType === "admin" && allowEdit)) &&
                                                                            <li key={plantingRecord.id + '-' + actionMenuItem.id}>
                                                                                {actionMenuItem.onClick ? (
                                                                                    <Link
                                                                                        to="#"
                                                                                        className="dropdown-item"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault(); // Prevent default anchor behavior
                                                                                            actionMenuItem.onClick(plantingRecord);
                                                                                        }}
                                                                                        style={
                                                                                            isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                ? { color: "#ff5a5f" }
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                    </Link>
                                                                                ) : (
                                                                                    <Link
                                                                                        to={actionMenuItem.routerPath + "/" + plantingRecord.id} // Changed href to to
                                                                                        className="dropdown-item"
                                                                                        style={
                                                                                            isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                ? { color: "#ff5a5f" }
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                    </Link>
                                                                                )}
                                                                            </li>
                                                                        }
                                                                    </>
                                                                ))}

                                                            </ul>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                </tbody>
                            </table>
                            {/* Delete Modal */}
                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title style={{ color: 'white' }}>Delete Planting</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p className="mb-4">
                                        Are you sure you want to delete this planting record?
                                    </p>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleCloseDeleteModal}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemovePlanting}>
                                        Delete
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* View Modal */}
                            <Modal size="lg" show={showViewModal} onHide={handleCloseViewModal}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Planting Record Details</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {selectedRecord ? (
                                        <div className="formView">
                                            <p><strong>Code:</strong> {selectedRecord.code ? selectedRecord.code : "N/A"}</p>
                                            <p><strong>Date:</strong> {isoToDate(selectedRecord.date)}</p>
                                            <p><strong>Serial Number:</strong> {selectedRecord.serialNumber}</p>
                                            <p><strong>Expected Yield:</strong> {selectedRecord.expectedYield}</p>
                                            <p><strong>Planting Material Form:</strong> {selectedRecord.plantingMaterialForm}</p>
                                            <p><strong>Source:</strong> {selectedRecord.source}</p>
                                            <p><strong>Treatment Before Planting:</strong> {selectedRecord.treatmentBeforePlanting}</p>
                                            <p><strong>Plant Population: </strong>{selectedRecord.plantPopulation ? selectedRecord.plantPopulation :"N/A"}</p>
                                            <p><strong>Expected Yield: </strong>{selectedRecord.expectedYield ? selectedRecord.expectedYield :"N/A"}</p>
                                            <p><strong>Associated Cost: </strong>GHS{selectedRecord.associatedCost ? selectedRecord.associatedCost :"N/A"}</p>

                                            {/* Environmental Conditions */}
                                            <hr/>
                                            <h4>Environmental Conditions</h4>
                                            {selectedRecord.environmentalCondition ? (
                                                <div>
                                                    <p><strong>Temperature:</strong> {selectedRecord.environmentalCondition.temperature}</p>
                                                    <p><strong>Weather Conditions:</strong> {selectedRecord.environmentalCondition.weatherConditions}</p>
                                                    <p><strong>Humidity:</strong> {selectedRecord.environmentalCondition.humidity ? selectedRecord.environmentalCondition.humidity :"N/A"}</p>
                                                    <p><strong>Rainfall:</strong> {selectedRecord.environmentalCondition.rainfall ? selectedRecord.environmentalCondition.rainfall :"N/A"}</p>
                                                    <p><strong>Wind Speed:</strong> {selectedRecord.environmentalCondition.windSpeed ? selectedRecord.environmentalCondition.windSpeed :"N/A"}</p>
                                                    <p><strong>Recorded Date:</strong> {isoToDate(selectedRecord.environmentalCondition.recordedDate)}</p>
                                                    <p><strong>Effects:</strong> {selectedRecord.environmentalCondition.effects}</p>
                                                </div>
                                            ) : (
                                                <p>No environmental conditions data available.</p>
                                            )}
                                        </div>
                                    ) : (
                                        <p>No record selected.</p>
                                    )}

                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseViewModal}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PlantingTable;